import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../lib";
export class ApiSmpFacecontrol {
}
/**
 * Used to get instagram facecontrol status
 */
ApiSmpFacecontrol.accountStatusGet = ({ externalId, }) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/facecontrol/v1/approve-target/instagram:${externalId}`,
    method: "GET",
});
/**
 * Used to get all instagram accounts using facecontrol
 */
ApiSmpFacecontrol.accountsStatus = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_SMP_API}/facecontrol/v1/approve-target/`,
    method: "GET",
    next: req === null || req === void 0 ? void 0 : req.next,
});
/**
 * Used to set facecontrol status for provided medium ()
 */
ApiSmpFacecontrol.post = ({ externalId, medium, }) => apiRequest({
    body: { external_id: externalId, medium },
    endpoint: `${REACT_APP__URL_SMP_API}/facecontrol/v1/approve-target/`,
    method: "POST",
});
/**
 * Used to unset facecontrol status for provided medium ()
 */
ApiSmpFacecontrol.remove = ({ externalId, medium, }) => apiRequest({
    body: { external_id: externalId, medium },
    endpoint: `${REACT_APP__URL_SMP_API}/facecontrol/v1/approve-target/instagram:${externalId}`,
    method: "DELETE",
});
//# sourceMappingURL=face_control.js.map